import { render } from "./AuthApps.vue?vue&type=template&id=482fba3a&scoped=true"
import script from "./AuthApps.vue?vue&type=script&lang=js"
export * from "./AuthApps.vue?vue&type=script&lang=js"

import "./AuthApps.vue?vue&type=style&index=0&id=482fba3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482fba3a"]])

export default __exports__